import { AnimalListingFragment } from "@/__generated__/graphql";
import Error404 from "@/errorPages/Error404";
import Error500 from "@/errorPages/Error500";
import { getAnimalPage } from "@api/graphql/queries";
import AnimalListing from "@cmsPages/AnimalListing";
import { initializeApollo } from "@lib/apolloClient";
import { getFrontendHostname, getTheme } from '@lib/config';
import type { GetServerSideProps, GetServerSidePropsContext, NextPage } from "next";

type AnimalPageProps = {
  data: {
    animals: AnimalListingFragment;
  };
  pageUrl: string;
  siteName: string;
  homepageUrl: string;
  errorCode?: number;
};

const AnimalPage: NextPage<AnimalPageProps> = (props: AnimalPageProps) => {
  if (props.errorCode === 500) {
    return <Error500 />;
  }
  else if (props.errorCode) {
    return <Error404 />;
  }

  return <AnimalListing pageUrl={props.pageUrl} {...props.data.animals} />;
};

export default AnimalPage;

export const getServerSideProps: GetServerSideProps = async (context: GetServerSidePropsContext) => {
  const { res, req } = context;
  const theme = getTheme();
  const path = context.resolvedUrl;
  const hostname = getFrontendHostname();

  let pageUrl;
  if (req) {
    // Server side rendering
    pageUrl = 'https://' + hostname + req.url;
  } else {
    // Client side rendering
    pageUrl = window.location.href;
  }

  // Get current params for the query.
  const params = new URL(pageUrl).searchParams;
  // Page number
  const page = (Number.parseInt(params.get('page') || '0|') - 1) || 0;
  // Tag filters.
  const type = params.getAll('animal_type');
  const flatType = type ? type.map((value) => value.split(',')).flat() : null;

  const apolloClient = initializeApollo();
  const result = await apolloClient.query({
    query: getAnimalPage,
    variables: {
      page: Math.max(page, 0),
      filterType: flatType || null,
    }
  })
  .catch((e) => {
    res.statusCode = 500;
    return {
      data: {
        route:{}
      },
      errorCode: 500
    };
  });

  return {
    props: {
      theme: theme,
      pageUrl: pageUrl,
      hostname: hostname,
      ...result
    },
  };
};
